import CountrySelector from "./CountrySelector";
import DateTime from "./DateTime";

function TitleBar({ title }) {
  return (
    <div>
      <div className="flex justify-between items-center">
        <h2 className="font-semibold text-2xl text-themeDark">{title}</h2>
        <div className="flex justify-end items-center">
          <CountrySelector />
          <div className="ml-3">
            <DateTime />
          </div>
        </div>
      </div>
    </div>
  );
}

export default TitleBar;
